import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import translationEN from "./en/translation.json";
import translationDE from "./de/translation.json";
var resources = {
    en: {
        translation: translationEN
    },
    de: {
        translation: translationDE
    }
};
i18n
    .use(detector)
    .use(initReactI18next)
    .init({
    resources: resources,
    debug: false,
    fallbackLng: 'de',
});
export default i18n;
